import { jsx as _jsx } from "react/jsx-runtime";
import { Trash as TrashIcon } from "@air/next-icons";
import { useAirModal } from "@air/provider-modal";
import { itemIsSelectedSelector } from "@air/redux-selected-items";
import { memo } from "react";
import { BoardCollectionDeleteClipsModal } from "~/components/BoardCollection/BoardCollectionDeleteClipsModal";
import { CardAction } from "~/components/CardAction";
import { selectedClipsSelector } from "~/store/selectedItems/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
export const ContentCollectionGalleryAssetDeleteButton = /*#__PURE__*/ memo((param)=>{
    let { clip } = param;
    const store = useAirStore();
    const [showBoardCollectionDeleteClipsModal] = useAirModal(BoardCollectionDeleteClipsModal);
    return /*#__PURE__*/ _jsx(CardAction, {
        icon: /*#__PURE__*/ _jsx(TrashIcon, {
            className: "size-4"
        }),
        onClick: ()=>{
            const isSelected = itemIsSelectedSelector(store.getState(), clip.id);
            showBoardCollectionDeleteClipsModal({
                clips: isSelected ? selectedClipsSelector(store.getState()) : [
                    clip
                ]
            });
        }
    });
});
ContentCollectionGalleryAssetDeleteButton.displayName = "ContentCollectionGalleryAssetDeleteButton";
